import * as React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRemove } from "@fortawesome/free-solid-svg-icons";

interface Props extends React.PropsWithChildren {
  onDelete: () => void;
}

const Wrapper = styled.div`
  display: flex;
  background-color: rgb(89, 96, 100);
  color: rgb(231, 229, 226);
  display: inline-block;
  font-size: 0.8rem;
  line-height: 1;
  white-space: nowrap;
  cursor: default;

  & > div {
    display: inline-block;
  }

  & > .delete {
    padding: 0.5rem;

    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
    }
  }

  & > .content {
    padding: 0.33333rem 0.5rem;
    padding-left: 0;
  }
`;

const FilterEntry = ({ children, onDelete }: Props) => {
  return (
    <Wrapper>
      <div className="delete" onClick={onDelete} title="Ta bort filter">
        <FontAwesomeIcon icon={faRemove} />
      </div>
      <div className="content">{children}</div>
    </Wrapper>
  );
};

export default FilterEntry;
